import {
	Grid,
	Input,
	MenuItem,
	Select,
	Typography,
	WithStyles,
} from '@material-ui/core';
import blueGrey from '@material-ui/core/colors/blueGrey';
import Paper from '@material-ui/core/Paper';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import * as React from 'react';
import { connect } from 'react-redux';
import { StaticContext } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import { ICareerMapCell, ICareerMapField } from 'src/actions/skill';
import ProcessStatusSubTable from 'src/components/ProcessStatusSubTable';
import ReactTable, {
	RowInfo,
	RowRenderProps,
} from '../components/MyReactTable';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import ScenarioFactory, {
	ISearchCellParam,
	ISearchFieldParam,
} from '../scenario/ProcessStatusScenarioFactory';
const styles = (theme: Theme) =>
	createStyles({
		menuButton: {
			height: '32px',
			width: '32px',
		},
		paper: {
			margin: theme.spacing(2),
			padding: theme.spacing(2),
		},
		selectedRow: {
			background: `${theme.palette.secondary.light} !important`,
			color: `${theme.palette.secondary.contrastText} !important`,
		},
		subComponent: {
			borderLeftColor: blueGrey[100],
			borderLeftStyle: 'solid',
			borderLeftWidth: theme.spacing(1),
			marginBottom: theme.spacing(2),
			marginLeft: theme.spacing(1),
			marginRight: theme.spacing(1),
			paddingLeft: theme.spacing(1),
		},
		whiteSpace: {
			whiteSpace: 'normal',
			width: '200px',
		},
		whiteSpaceMenuItem: {
			whiteSpace: 'normal',
			wordBreak: 'break-all',
		},

		rowDarkColor: {
			'&:hover': {
				backgroundColor: '#FFD6DA !important',
			},
			backgroundColor: '#FFE1E4 !important',
		},
		rowLightColor: {
			'&:hover': {
				backgroundColor: '#FFD6DA !important',
			},
			backgroundColor: 'rgba(255,214,218,0.93) !important',
		},
	});

interface IRouteParams {
	skill_map_id: string;
	user_id: string;
}

// tslint:disable-next-line:no-empty-interface
interface IRouteState {}

interface IState {
	data: ICareerMapCell[];
	functionMenus?: JSX.Element;
	levelOneID: string;
	levelTwoID: string;
	levelThreeID: string;
	fieldlevelTwo: ICareerMapField[];
	fieldlevelThree: ICareerMapField[];
	cmId: string;
	targetUserId: string;
}

class ProcessStatus extends React.Component<IProps, IState> {
	public constructor(props: IProps) {
		super(props);
		this.state = {
			cmId: '',
			data: [],
			levelOneID: 'unselected',
			levelThreeID: 'unselected',
			levelTwoID: 'unselected',

			fieldlevelThree: [],
			fieldlevelTwo: [],
			targetUserId: '',
		};
		this.onChangeField = this.onChangeField.bind(this);
	}

	public componentDidMount() {
		window.scrollTo({
			top: 0,
		});
		if (!this.props.match || !this.props.match.params) {
			return;
		}
		const cmId = this.props.match.params.skill_map_id;
		const targetUserId = this.props.match.params.user_id;
		this.setState({
			cmId,
			targetUserId,
		});
		const param: ISearchFieldParam = {
			cmId,
			userAttr: this.props.userAttr,
		};
		this.props.fetchCareerMapField(this.props.token, param);
	}

	public render() {
		const { classes } = this.props;
		const columns = this.getAllColumns();

		return (
			<>
				<Paper className={classes.paper}>
					<div>
						<h3>
							{i18n.t('ProcessStatus_0001')} :&nbsp;&nbsp;
							{this.props.careerMapName}
						</h3>
					</div>
					<div>
						<Grid container={true} spacing={6}>
							<Grid item={true}>
								{i18n.t('ProcessStatus_0002')}
								<Select
									id="levelOne"
									input={<Input name="levelOne" />}
									autoWidth={false}
									displayEmpty={false}
									classes={{
										selectMenu: this.props.classes
											.whiteSpace,
									}}
									value={this.state.levelOneID}
									onChange={this.onChangeField}
								>
									<MenuItem
										className={
											this.props.classes
												.whiteSpaceMenuItem
										}
										value={'unselected'}
									>
										{i18n.t('ProcessStatus_0003')}
									</MenuItem>
									{this.props.fieldlevelOne &&
										this.props.fieldlevelOne.map(
											(option, j) => (
												<MenuItem
													key={j}
													className={
														this.props.classes
															.whiteSpaceMenuItem
													}
													value={option.fieldID}
												>
													{option.fieldTitle}
												</MenuItem>
											)
										)}
								</Select>
							</Grid>
							<Grid item={true}>
								{i18n.t('ProcessStatus_0004')}
								<Select
									id="levelTwo"
									input={<Input name="levelTwo" />}
									autoWidth={false}
									displayEmpty={false}
									classes={{
										selectMenu: this.props.classes
											.whiteSpace,
									}}
									value={this.state.levelTwoID}
									onChange={this.onChangeField}
								>
									<MenuItem
										className={
											this.props.classes
												.whiteSpaceMenuItem
										}
										value={'unselected'}
									>
										{i18n.t('ProcessStatus_0005')}
									</MenuItem>
									{this.state.fieldlevelTwo &&
										this.state.fieldlevelTwo.map(
											(option, j) => (
												<MenuItem
													key={j}
													className={
														this.props.classes
															.whiteSpaceMenuItem
													}
													value={option.fieldID}
												>
													{option.fieldTitle}
												</MenuItem>
											)
										)}
								</Select>
							</Grid>
							<Grid item={true}>
								{i18n.t('ProcessStatus_0006')}
								<Select
									id="levelThree"
									input={<Input name="levelThree" />}
									autoWidth={false}
									displayEmpty={false}
									classes={{
										selectMenu: this.props.classes
											.whiteSpace,
									}}
									value={this.state.levelThreeID}
									onChange={this.onChangeField}
								>
									<MenuItem
										className={
											this.props.classes
												.whiteSpaceMenuItem
										}
										value={'unselected'}
									>
										{i18n.t('ProcessStatus_0007')}
									</MenuItem>
									{this.state.fieldlevelThree &&
										this.state.fieldlevelThree.map(
											(option, j) => (
												<MenuItem
													key={j}
													className={
														this.props.classes
															.whiteSpaceMenuItem
													}
													value={option.fieldID}
												>
													{option.fieldTitle}
												</MenuItem>
											)
										)}
								</Select>
							</Grid>
						</Grid>
					</div>
				</Paper>
				<Paper className={classes.paper}>
					<ReactTable
						data={this.state.data}
						columns={columns}
						getTrProps={this.setRowColorOfCell(classes)}
						defaultPageSize={10}
						className="-striped -highlight"
						SubComponent={this.subComponent}
					/>
				</Paper>
			</>
		);
	}

	protected setRowColorOfCell = (classes: Record<string, string>) => (
		state: any,
		rowInfo: RowInfo
	) => {
		if (rowInfo === undefined) {
			return {};
		}
		let className: any = '';
		if (rowInfo.original.statusId === '9') {
			if (rowInfo.index % 2 === 0) {
				className = classes.rowDarkColor;
			} else {
				className = classes.rowLightColor;
			}
		}
		return { className };
	};

	protected onChangeField(event: React.ChangeEvent<HTMLSelectElement>) {
		const { name, value } = event.target;
		if (name === 'levelOne' && this.props.fieldlevelOne.length > 0) {
			const fieldlevelTwo: ICareerMapField[] = [];
			this.props.fieldlevelTwo.forEach(item => {
				if (item.parentFieldID === value) {
					fieldlevelTwo.push(item);
				}
			});
			this.setState({
				fieldlevelThree: [],
				fieldlevelTwo,
				levelOneID: value,
				levelThreeID: 'unselected',
				levelTwoID: 'unselected',
			});
			if (value !== 'unselected') {
				const param: ISearchCellParam = {
					cmId: this.state.cmId,
					fieldID: value,
					fieldLevel: '1',
					userAttr: this.props.userAttr,
					userId: this.props.adminView
						? this.state.targetUserId
						: this.props.userAttr.userId,
				};
				this.props
					.fetchCareerMapCell(this.props.token, param)
					.then(() => {
						this.setState({
							data: this.props.careerMapCellList,
						});
					});
			} else {
				this.setState({
					data: [],
				});
			}
		}
		if (name === 'levelTwo' && this.props.fieldlevelTwo.length > 0) {
			const fieldlevelThree: ICareerMapField[] = [];
			this.props.fieldlevelThree.forEach(item => {
				if (item.parentFieldID === value) {
					fieldlevelThree.push(item);
				}
			});
			this.setState({
				fieldlevelThree,
				levelThreeID: 'unselected',
				levelTwoID: value,
			});

			if (value !== 'unselected') {
				const param: ISearchCellParam = {
					cmId: this.state.cmId,
					fieldID: value,
					fieldLevel: '2',
					userAttr: this.props.userAttr,
					userId: this.props.adminView
						? this.state.targetUserId
						: this.props.userAttr.userId,
				};
				this.props
					.fetchCareerMapCell(this.props.token, param)
					.then(() => {
						this.setState({
							data: this.props.careerMapCellList,
						});
					});
			} else {
				const param: ISearchCellParam = {
					cmId: this.state.cmId,
					fieldID: this.state.levelOneID,
					fieldLevel: '1',
					userAttr: this.props.userAttr,
					userId: this.props.adminView
						? this.state.targetUserId
						: this.props.userAttr.userId,
				};
				this.props
					.fetchCareerMapCell(this.props.token, param)
					.then(() => {
						this.setState({
							data: this.props.careerMapCellList,
						});
					});
			}
		}
		if (name === 'levelThree') {
			this.setState({
				levelThreeID: value,
			});

			if (value !== 'unselected') {
				const param: ISearchCellParam = {
					cmId: this.state.cmId,
					fieldID: value,
					fieldLevel: '3',
					userAttr: this.props.userAttr,
					userId: this.props.adminView
						? this.state.targetUserId
						: this.props.userAttr.userId,
				};
				this.props
					.fetchCareerMapCell(this.props.token, param)
					.then(() => {
						this.setState({
							data: this.props.careerMapCellList,
						});
					});
			} else {
				if (this.state.levelTwoID !== 'unselected') {
					const param: ISearchCellParam = {
						cmId: this.state.cmId,
						fieldID: this.state.levelTwoID,
						fieldLevel: '2',
						userAttr: this.props.userAttr,
						userId: this.props.adminView
							? this.state.targetUserId
							: this.props.userAttr.userId,
					};
					this.props
						.fetchCareerMapCell(this.props.token, param)
						.then(() => {
							this.setState({
								data: this.props.careerMapCellList,
							});
						});
				} else {
					if (this.state.levelOneID !== 'unselected') {
						const param: ISearchCellParam = {
							cmId: this.state.cmId,
							fieldID: this.state.levelOneID,
							fieldLevel: '1',
							userAttr: this.props.userAttr,
							userId: this.props.adminView
								? this.state.targetUserId
								: this.props.userAttr.userId,
						};
						this.props
							.fetchCareerMapCell(this.props.token, param)
							.then(() => {
								this.setState({
									data: this.props.careerMapCellList,
								});
							});
					} else {
						this.setState({
							data: [],
						});
					}
				}
			}
		}
	}

	/**
	 * 表のサブコンポーネント
	 */
	protected subComponent = (row: RowInfo) => {
		if (row.original.cellSubCareer.length === 0) {
			return (
				<div className={this.props.classes.subComponent}>
					<Typography>{i18n.t('ProcessStatus_0008')}</Typography>
				</div>
			);
		} else {
			return (
				<ProcessStatusSubTable
					cellSubCareer={row.original.cellSubCareer}
					adminView={this.props.adminView}
				/>
			);
		}
	};

	/**
	 * 全カラム定義取得
	 */
	protected getAllColumns(): any[] {
		return [
			{
				Header: i18n.t('ProcessStatus_0009'),
				accessor: 'fieldName1',
				width: 150,
			},
			{
				Header: i18n.t('ProcessStatus_0010'),
				accessor: 'fieldName2',
				width: 150,
			},
			{
				Header: i18n.t('ProcessStatus_0011'),
				accessor: 'fieldName3',
				width: 150,
			},
			{
				Cell: (row: RowRenderProps) => {
					let levelTitle = row.value;
					if (levelTitle && levelTitle.indexOf('レベル') !== -1) {
						levelTitle = levelTitle.replace(
							'レベル',
							i18n.t('レベル', {
								ns: 'force',
							})
						);
					}
					return levelTitle;
				},
				Header: i18n.t('ProcessStatus_0012'),
				accessor: 'levelTitle',
				width: 150,
			},
			{
				Header: i18n.t('ProcessStatus_0013'),
				accessor: 'contents',
				width: 300,
			},
			{
				Header: i18n.t('ProcessStatus_0014'),
				accessor: 'careerCount',
				width: 200,
			},
			{
				Cell: (row: RowRenderProps) =>
					i18n.t(row.value, { ns: 'force' }),
				Header: i18n.t('ProcessStatus_0015'),
				accessor: 'status',
				width: 200,
			},
		];
	}
}

const mapStateToProps = (state: IRootState) => ({
	token: state.session.token,
	userAttr: state.session.userAttr,

	careerMapCellList: state.skill.careerMapCellList,
	careerMapName: state.skill.careerMapFieldList.careerMapName,
	fieldlevelOne: state.skill.careerMapFieldList.fieldlevelOne,
	fieldlevelThree: state.skill.careerMapFieldList.fieldlevelThree,
	fieldlevelTwo: state.skill.careerMapFieldList.fieldlevelTwo,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	fetchCareerMapCell: (token: string, arg: ISearchCellParam) => {
		const s = ScenarioFactory.FetchCarerrMapCell(dispatch, token);
		return s.run(arg);
	},
	fetchCareerMapField: (token: string, arg: ISearchFieldParam) => {
		const s = ScenarioFactory.FetchCareerMapField(dispatch, token);
		return s.run(arg);
	},
});

export interface IProcessStatusProps {
	adminView: boolean;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> &
	RouteComponentProps<IRouteParams, StaticContext, IRouteState> &
	IProcessStatusProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(ProcessStatus);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/ProcessStatus.tsx